import { TranslationService } from "../../../../services/TranslationService";
import { CompanySettings } from "../../../../entities/company/Company/CompanySettings";
import { useContext, useState, useMemo } from "react";
import Loading from "../../../shared/components/Loading";
import ConfigurationContext from "../../ConfigurationContext";
import CompanyService from "../../../../services/CompanyService";
import Dropdown from "../../../shared/components/Dropdown";

type DropdownSelectWrapperType = {
  initialValue?: string | number | null;
  action?: keyof CompanySettings;
  title?: string;
  fullSize?: boolean;
};

export const FinalStatusPaymentLink = ({
  title,
  action,
  initialValue = null,
  fullSize = false
}: DropdownSelectWrapperType) => {
  const [loading, setLoading] = useState(false);
  const { refreshConfigValues } = useContext(ConfigurationContext);

  const items = useMemo(() => {
    return CompanyService.getIoStatus().map((status) => ({
      value: status.IOStatusID.toString(),
      text: status.Value
    }));
  }, []);

  const initialValueString = useMemo(() => {
    if (initialValue === null || initialValue === undefined) {
      return null;
    }
    return typeof initialValue === "number"
      ? initialValue.toString()
      : initialValue;
  }, [initialValue]);

  const handleSelect = (valueUpdated: any) => {
    setLoading(true);

    action &&
      CompanyService.setConfigCompany({ [action]: valueUpdated }).finally(
        async () => {
          await refreshConfigValues();
          await setLoading(false);
        }
      );
  };

  return loading ? (
    <Loading />
  ) : (
    <div
      className={`d-flex ${fullSize ? "" : "col-md-8"} justify-content-between align-items-center`}
    >
      {title && (
        <td className="col py-0">
          <div className="configuration-display-item">
            {TranslationService.getTranslation(title)}
          </div>
        </td>
      )}
      <td className={`col${title ? "-sm-5" : ""} py-0`}>
        <Dropdown
          items={items}
          onChange={handleSelect}
          value={initialValueString}
        />
      </td>
    </div>
  );
};
